var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 76,
    viewBox: "0 0 188 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M169.336 39.7519C166.442 39.7519 163.709 40.4078 161.266 41.5635C161.475 40.6109 161.587 39.627 161.587 38.6118C161.587 30.7406 155.028 24.3687 146.926 24.3687C143.614 24.3687 140.56 25.4463 138.1 27.2579C133.341 15.6385 121.686 7.42373 108.022 7.42373C101.8 7.42373 95.9968 9.12603 91.0775 12.0777C89.3574 5.22166 83.0234 0.114746 75.4355 0.114746C67.285 0.114746 60.5813 5.98691 59.4881 13.6082C57.6715 13.249 55.7906 13.0616 53.8615 13.0616C38.1391 13.0616 25.3908 25.4463 25.3908 40.7202C25.3908 42.0477 25.5194 43.3439 25.7123 44.6246C24.8121 44.1717 23.8153 43.8906 22.7222 43.8906C19.1372 43.8906 16.2274 46.7017 16.1792 50.1688C15.4558 50.0595 14.7324 49.9814 13.9768 49.9814C6.58181 49.9814 0.585449 55.8067 0.585449 62.9907C0.585449 70.1748 6.58181 76.0001 13.9768 76.0001H169.336C179.64 76.0001 188 67.879 188 57.8682C188 47.873 179.64 39.7519 169.336 39.7519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCloud);
export default __webpack_public_path__ + "static/media/Right Cloud.05494f945a8318a82b567ec93d440040.svg";
export { ForwardRef as ReactComponent };